import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text from '@lightspeed/cirrus-text';
import cn from 'classnames';
import { Button } from '@lightspeed/flame/Button';
import { IconClipboard } from '@lightspeed/flame/Icon/Clipboard';

import { breakTextIntoLines } from 'pages/utils/text';

class TextPane extends Component {
  constructor(props) {
    super(props);
    this.handleCopyToClipboard = this.handleCopyToClipboard.bind(this);
    this.textareaRef = React.createRef();
  }

  handleCopyToClipboard() {
    this.textareaRef.current.select();
    document.execCommand('copy');
  }

  render() {
    const { code, clipboard, className, style = {}, children } = this.props;
    const cls = cn('text-pane', className, { 'text-pane--code': code, 'cr-monospace': code });
    return (
      <div className={cls} style={style}>
        <Text dimmed className="text-pane__content">
          {breakTextIntoLines({ text: children, lineBreak: '\n', lineClass: 'text-pane__line' })}
        </Text>
        {clipboard && (
          <Button size="small" onClick={this.handleCopyToClipboard}>
            <IconClipboard />
            Copy to Clipboard
          </Button>
        )}
        {clipboard && (
          <textarea
            ref={this.textareaRef}
            className="text-pane__textarea"
            defaultValue={children}
          />
        )}
      </div>
    );
  }
}

TextPane.propTypes = {
  code: PropTypes.bool,
  clipboard: PropTypes.bool,
  children: PropTypes.string,
};

TextPane.defaultProps = {
  code: false,
  clipboard: false,
  children: '',
};

export default TextPane;
